export const DASH = {
  navDashboard: "nav-dashboard",
  page: "dashboard-page",
  title: "dashboard-title",
  welcome: "dashboard-welcome",
  cardPatients: "dashboard-card-patients",
  cardEncounters: "dashboard-card-encounters",
  cardIcd10: "dashboard-card-icd10-cm",
  cardCpt: "dashboard-card-cpt",
  cardPxMaster: "dashboard-card-px-master",
  cardAllergenMaster: "dashboard-card-allergen-master",
  cardMedications: "dashboard-card-medications",
  cardLabs: "dashboard-card-labs",
  cardRadiology: "dashboard-card-radiology",
  cardPhysicianReferrals: "dashboard-card-physician-referrals",
  cardReferringProviders: "dashboard-card-referring-providers",
  cardPlaceholderVocabulary: "dashboard-card-placeholder-vocabulary",
  cardReports: "dashboard-card-reports",
  cardUsers: "dashboard-card-users",
  cardAccessControl: "dashboard-card-access-control",
  clinicalFoundation: "dashboard-clinical-foundation",
  nextAreas: "dashboard-next-areas",
};
